import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { v4 as uuidv4 } from "uuid";
import { fb } from "../firebase-config";
import DB from "../services/firestoredb";

const db = fb;

const TokenGenerate = () => {
    const { docId } = useParams();
    const [email, setEmail] = useState("");
    const [secret, setSecret] = useState("");
    const [pwd, setPwd] = useState("");
    const [token, setToken] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const [step, setStep] = useState("checking");
    const [userIndex, setUserIndex] = useState(null);
    const [confirmPwd, setConfirmPwd] = useState("");
    const [environment, setEnvironment] = useState("");
    const [username, setUserName] = useState("");

    useEffect(() => {
        const validateDocId = async () => {
            setLoading(true);
            const result = await DB.validateOnBoardDocId(docId);

            /*
            if (typeof result === "string") {
                setError(result);
                setStep("invalid");
            } else {
                setUserIndex(result);
                setStep("form");
            }
            */

            if (typeof result === "string") {
                setError(result);
                setStep("invalid");
            } else {
                setUserIndex(result.userIndex);
                setEnvironment(result.isLive ? "Production" : "Sandbox");
                setUserName(result.user);
                setEmail(result.email);
                setStep("form");
            }

            setLoading(false);
        };

        validateDocId();
    }, [docId]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setToken("");
        setLoading(true);

        if (pwd !== confirmPwd) {
            setError("Passwords do not match.");
            setLoading(false);
            return;
        }

        const result = await DB.generateOnboardingUserToken({
            email,
            password: pwd,
            confirmPassword: confirmPwd,
            secretKey: secret,
            userIndex
        });

        if (!result.success) {
            setError(result.message);
            setStep("invalid");
        } else {
            setToken(result.token);
            setStep("done");
        }

        // try {
        //     const ref = doc(db, "securityToken", "batchProcessAPI");
        //     const docSnap = await getDoc(ref);
        //     if (!docSnap.exists()) throw new Error("Document not found");

        //     const users = [...(docSnap.data().user || [])];
        //     const user = users[userIndex];

        //     if (user.email !== email || user.secretKey !== secret) {
        //         setError("Invalid email or secret key or password.");
        //         setLoading(false);
        //         return;
        //     }

        //     const generatedToken = uuidv4();
        //     user.token = generatedToken;
        //     user.tokenCreatedAt = new Date().toISOString();
        //     user.isTokenGenerated = true;

        //     users[userIndex] = user;
        //     await updateDoc(ref, { user: users });

        //     setToken(generatedToken);
        //     setStep("done");
        // } catch (err) {
        //     console.error(err);
        //     setError("Error generating token. Please try again.");
        // }

        setLoading(false);
    };

    return (
        <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
            {/* Header */}
            <div style={{ backgroundColor: "#00a1be", position: "relative", height: "143px", display: "flex", alignItems: "flex-end", justifyContent: "center", padding: "10px" }}>
                <div
                    style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        opacity: 0.5,
                        backgroundImage: 'url(https://latpay.com/wp-content/themes/enfold/images/background-images/dots-mini-light.png)',
                        backgroundRepeat: 'repeat',
                        zIndex: 1,
                    }}
                ></div>
                <div style={{ display: "flex", alignItems: "center", zIndex: 2 }}>
                    <h1 style={{ color: "whitesmoke", fontSize: "42px", margin: 0 }}>
                        ONBOARDING REGISTRATION
                    </h1>
                </div>
            </div>

            {/* Main content */}
            <div
                style={{
                    flex: 1,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: "60px 20px",
                    background: "linear-gradient(135deg, #f5f7fa 0%, #e4ecf7 100%)"
                }}
            >
                <div
                    style={{
                        width: "100%",
                        maxWidth: "480px",
                        backgroundColor: "#ffffff",
                        padding: "40px",
                        borderRadius: "14px",
                        boxShadow: "0 20px 40px rgba(0, 0, 0, 0.08)",
                        border: "1px solid rgba(0,0,0,0.04)"
                    }}
                >
                    {step === "checking" && (
                        <p style={{ textAlign: "center" }}>Checking link validity...</p>
                    )}

                    {step === "form" && (
                        <>
                            <div style={{ textAlign: "center", marginBottom: "30px" }}>
                                <h2
                                    style={{
                                        margin: 0,
                                        fontSize: "26px",
                                        fontWeight: "600",
                                        color: "#122051"
                                    }}
                                >
                                    Generate Bearer Token
                                </h2>
                                <p
                                    style={{
                                        fontSize: "13px",
                                        color: "#7a869a",
                                        marginTop: "6px"
                                    }}
                                >
                                    🔒 Secure onboarding access
                                </p>
                            </div>

                            <form onSubmit={handleSubmit}>
                                {/* Reusable input style */}
                                {(() => {
                                    const inputStyle = {
                                        width: "100%",
                                        padding: "12px 14px",
                                        borderRadius: "8px",
                                        border: "1px solid #d6dde8",
                                        fontSize: "14px",
                                        transition: "all 0.2s ease",
                                        outline: "none"
                                    };

                                    return (
                                        <>
                                            {/* User Name */}
                                            <div style={{ marginBottom: "25px" }}>
                                                <label style={{
                                                    display: "block",
                                                    marginBottom: "6px",
                                                    fontWeight: "600",
                                                    fontSize: "13px",
                                                    color: "#5f6b7a"
                                                }}>
                                                    Username
                                                </label>

                                                <div style={{
                                                    padding: "12px",
                                                    borderRadius: "8px",
                                                    fontWeight: "600",
                                                    fontSize: "14px",
                                                    backgroundColor: username === "Production" ? "#ffe9e9" : "#e7f7ef",
                                                    color: username === "Production" ? "#d93025" : "#137333",
                                                    border: username === "Production"
                                                        ? "1px solid #ffc9c9"
                                                        : "1px solid #b7ebc6"
                                                }}>
                                                    {username}
                                                </div>
                                            </div>
                                            {/* Email ID */}
                                            <div style={{ marginBottom: "25px" }}>
                                                <label style={{
                                                    display: "block",
                                                    marginBottom: "6px",
                                                    fontWeight: "600",
                                                    fontSize: "13px",
                                                    color: "#5f6b7a"
                                                }}>
                                                    Email ID
                                                </label>

                                                <div style={{
                                                    padding: "12px",
                                                    borderRadius: "8px",
                                                    fontWeight: "600",
                                                    fontSize: "14px",
                                                    backgroundColor: email === "Production" ? "#ffe9e9" : "#e7f7ef",
                                                    color: email === "Production" ? "#d93025" : "#137333",
                                                    border: email === "Production"
                                                        ? "1px solid #ffc9c9"
                                                        : "1px solid #b7ebc6"
                                                }}>
                                                    {email}
                                                </div>
                                            </div>
                                            {/* Email */}
                                            {/* <div style={{ marginBottom: "18px" }}>
                                                <label style={{
                                                    display: "block",
                                                    marginBottom: "6px",
                                                    fontWeight: "600",
                                                    fontSize: "13px",
                                                    color: "#5f6b7a"
                                                }}>
                                                    Email ID
                                                </label>
                                                <input
                                                    type="email"
                                                    value={email}
                                                    onChange={(e) => setEmail(e.target.value)}
                                                    placeholder="Enter your email"
                                                    style={inputStyle}
                                                    onFocus={(e) => e.target.style.border = "1px solid #00a1be"}
                                                    onBlur={(e) => e.target.style.border = "1px solid #d6dde8"}
                                                    required
                                                />
                                            </div> */}
                                            {/* Secret Key */}
                                            <div style={{ marginBottom: "18px" }}>
                                                <label style={{
                                                    display: "block",
                                                    marginBottom: "6px",
                                                    fontWeight: "600",
                                                    fontSize: "13px",
                                                    color: "#5f6b7a"
                                                }}>
                                                    Secret Key
                                                </label>
                                                <input
                                                    type="password"
                                                    value={secret}
                                                    onChange={(e) => setSecret(e.target.value)}
                                                    placeholder="Enter your secret key"
                                                    style={inputStyle}
                                                    onFocus={(e) => e.target.style.border = "1px solid #00a1be"}
                                                    onBlur={(e) => e.target.style.border = "1px solid #d6dde8"}
                                                    required
                                                />
                                            </div>

                                            {/* Password */}
                                            <div style={{ marginBottom: "18px" }}>
                                                <label style={{
                                                    display: "block",
                                                    marginBottom: "6px",
                                                    fontWeight: "600",
                                                    fontSize: "13px",
                                                    color: "#5f6b7a"
                                                }}>
                                                    Password
                                                </label>
                                                <input
                                                    type="password"
                                                    value={pwd}
                                                    onChange={(e) => setPwd(e.target.value)}
                                                    placeholder="Enter your password"
                                                    style={inputStyle}
                                                    onFocus={(e) => e.target.style.border = "1px solid #00a1be"}
                                                    onBlur={(e) => e.target.style.border = "1px solid #d6dde8"}
                                                    required
                                                />
                                            </div>

                                            {/* Confirm Password */}
                                            <div style={{ marginBottom: "20px" }}>
                                                <label style={{
                                                    display: "block",
                                                    marginBottom: "6px",
                                                    fontWeight: "600",
                                                    fontSize: "13px",
                                                    color: "#5f6b7a"
                                                }}>
                                                    Confirm Password
                                                </label>
                                                <input
                                                    type="password"
                                                    value={confirmPwd}
                                                    onChange={(e) => setConfirmPwd(e.target.value)}
                                                    placeholder="Confirm your password"
                                                    style={inputStyle}
                                                    onFocus={(e) => e.target.style.border = "1px solid #00a1be"}
                                                    onBlur={(e) => e.target.style.border = "1px solid #d6dde8"}
                                                    required
                                                />
                                            </div>

                                            {/* Environment */}
                                            <div style={{ marginBottom: "25px" }}>
                                                <label style={{
                                                    display: "block",
                                                    marginBottom: "6px",
                                                    fontWeight: "600",
                                                    fontSize: "13px",
                                                    color: "#5f6b7a"
                                                }}>
                                                    Environment
                                                </label>

                                                <div style={{
                                                    padding: "12px",
                                                    borderRadius: "8px",
                                                    fontWeight: "600",
                                                    fontSize: "14px",
                                                    backgroundColor: environment === "Production" ? "#ffe9e9" : "#e7f7ef",
                                                    color: environment === "Production" ? "#d93025" : "#137333",
                                                    border: environment === "Production"
                                                        ? "1px solid #ffc9c9"
                                                        : "1px solid #b7ebc6"
                                                }}>
                                                    {environment}
                                                </div>
                                            </div>

                                            {/* Button */}
                                            <button
                                                type="submit"
                                                disabled={loading}
                                                style={{
                                                    width: "100%",
                                                    padding: "14px",
                                                    borderRadius: "8px",
                                                    border: "none",
                                                    fontSize: "15px",
                                                    fontWeight: "600",
                                                    color: "#fff",
                                                    background: "linear-gradient(135deg, #00a1be 0%, #007c99 100%)",
                                                    cursor: "pointer",
                                                    transition: "all 0.2s ease",
                                                    boxShadow: "0 6px 18px rgba(0,161,190,0.25)"
                                                }}
                                                onMouseOver={(e) =>
                                                    (e.target.style.transform = "translateY(-2px)")
                                                }
                                                onMouseOut={(e) =>
                                                    (e.target.style.transform = "translateY(0px)")
                                                }
                                            >
                                                {loading ? "Generating..." : "Generate Token"}
                                            </button>

                                            {error && (
                                                <div style={{
                                                    marginTop: "15px",
                                                    color: "#d93025",
                                                    fontSize: "13px",
                                                    fontWeight: "500"
                                                }}>
                                                    {error}
                                                </div>
                                            )}
                                        </>
                                    );
                                })()}
                            </form>
                        </>
                    )}

                    {/* {step === "done" && (
                        <div style={{
                            textAlign: "center",
                            color: "#137333",
                            fontWeight: "600",
                            wordBreak: "break-word"
                        }}>
                            ✅ Bearer Token Generated:
                            <div style={{ marginTop: "10px", fontSize: "13px" }}>
                                {token}
                            </div>
                        </div>
                    )} */}
                    {step === "done" && (
                        <div style={{ marginTop: "20px" }}>
                            <div style={{
                                backgroundColor: "#e7f7ef",
                                border: "1px solid #b7ebc6",
                                padding: "15px",
                                borderRadius: "8px"
                            }}>
                                <div style={{
                                    fontWeight: "600",
                                    marginBottom: "8px",
                                    color: "#137333"
                                }}>
                                    ✅ Bearer Token Generated Successfully
                                </div>

                                <textarea
                                    value={token}
                                    readOnly
                                    style={{
                                        width: "100%",
                                        height: "120px",
                                        padding: "10px",
                                        borderRadius: "6px",
                                        border: "1px solid #ccc",
                                        fontSize: "12px",
                                        resize: "none"
                                    }}
                                />

                                <button
                                    onClick={() => {
                                        navigator.clipboard.writeText(token);
                                    }}
                                    style={{
                                        marginTop: "10px",
                                        padding: "8px 12px",
                                        borderRadius: "6px",
                                        border: "none",
                                        backgroundColor: "#00a1be",
                                        color: "#fff",
                                        fontSize: "13px",
                                        cursor: "pointer"
                                    }}
                                >
                                    Copy Token
                                </button>
                            </div>
                        </div>
                    )}

                    {step === "invalid" && (
                        <div style={{
                            textAlign: "center",
                            color: "#d93025",
                            fontWeight: "600"
                        }}>
                            {error}
                        </div>
                    )}
                </div>
            </div>
            {/* <div style={{ flex: 1, display: "flex", justifyContent: "center", alignItems: "center", padding: "40px 20px" }}>
                <div style={{ width: "100%", maxWidth: "500px", backgroundColor: "#f9f9f9", padding: "30px", borderRadius: "8px", boxShadow: "0 4px 12px rgba(0,0,0,0.1)" }}>
                    {step === "checking" && <p>Checking link validity...</p>}

                    {step === "form" && (
                        <>
                            <h2 style={{ textAlign: "center", marginBottom: "20px", color: "#122051" }}>Generate Bearer Token</h2>
                            <form onSubmit={handleSubmit}>
                                <div style={{ marginBottom: "15px" }}>
                                    <label htmlFor="email" style={{ display: "block", marginBottom: "6px", fontWeight: "bold", color: "#666666" }}>Email ID</label>
                                    <input
                                        type="email"
                                        id="email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        placeholder="Enter your email"
                                        style={{ width: "100%", padding: "10px", borderRadius: "4px", border: "1px solid #ccc" }}
                                        required
                                    />
                                </div>
                                <div style={{ marginBottom: "20px" }}>
                                    <label htmlFor="secret" style={{ display: "block", marginBottom: "6px", fontWeight: "bold", color: "#666666" }}>Secret Key</label>
                                    <input
                                        type="password"
                                        id="secret"
                                        value={secret}
                                        onChange={(e) => setSecret(e.target.value)}
                                        placeholder="Enter your secret key"
                                        style={{ width: "100%", padding: "10px", borderRadius: "4px", border: "1px solid #ccc" }}
                                        required
                                    />
                                </div>
                                <div style={{ marginBottom: "20px" }}>
                                    <label htmlFor="pwd" style={{ display: "block", marginBottom: "6px", fontWeight: "bold", color: "#666666" }}>Password</label>
                                    <input
                                        type="password"
                                        id="pwd"
                                        value={pwd}
                                        onChange={(e) => setPwd(e.target.value)}
                                        placeholder="Enter your password"
                                        style={{ width: "100%", padding: "10px", borderRadius: "4px", border: "1px solid #ccc" }}
                                        required
                                    />
                                </div>
                                <div style={{ marginBottom: "20px" }}>
                                    <label htmlFor="confirmPwd" style={{ display: "block", marginBottom: "6px", fontWeight: "bold", color: "#666666" }}>
                                        Confirm Password
                                    </label>
                                    <input
                                        type="password"
                                        id="confirmPwd"
                                        value={confirmPwd}
                                        onChange={(e) => setConfirmPwd(e.target.value)}
                                        placeholder="Confirm your password"
                                        style={{ width: "100%", padding: "10px", borderRadius: "4px", border: "1px solid #ccc" }}
                                        required
                                    />
                                </div>
                                <div style={{ marginBottom: "20px" }}>
                                    <label style={{ display: "block", marginBottom: "6px", fontWeight: "bold", color: "#666666" }}>
                                        Environment
                                    </label>
                                    <input
                                        type="text"
                                        value={environment}
                                        readOnly
                                        style={{
                                            width: "100%",
                                            padding: "10px",
                                            borderRadius: "4px",
                                            border: "1px solid #ccc",
                                            backgroundColor: "#e9ecef",
                                            fontWeight: "bold",
                                            color: environment === "Production" ? "red" : "green"
                                        }}
                                    />
                                </div>
                                <button
                                    type="submit"
                                    style={{
                                        width: "100%",
                                        backgroundColor: "#00a1be",
                                        color: "#fff",
                                        padding: "12px",
                                        border: "none",
                                        borderRadius: "4px",
                                        fontWeight: "bold",
                                        cursor: "pointer"
                                    }}
                                    disabled={loading}
                                >
                                    {loading ? "Generating..." : "Generate Token"}
                                </button>
                            </form>
                        </>
                    )}

                    {step === "done" && (
                        <div style={{ color: "green", fontWeight: "bold", wordBreak: "break-word" }}>
                            Bearer Token generated:<br />{token}
                        </div>
                    )}

                    {step === "invalid" && (
                        <div style={{ color: "red", fontWeight: "bold" }}>{error}</div>
                    )}
                </div>
            </div> */}

            {/* Footer section */}
            <div style={{ backgroundColor: "#122051", padding: "20px 10px", textAlign: "center", color: "whitesmoke", fontSize: "12px" }}>
                <p style={{ margin: "5px auto", maxWidth: "800px" }}>
                    All Content Copyright © 2026 Latpay |
                    <a href="https://latpay.com/privacy-policy" target="_blank" rel="noreferrer" style={{ color: "#fff", textDecoration: "underline", margin: "0 5px" }}>Privacy Policy</a> |
                    <a href="https://latpay.com/terms-condition/" target="_blank" rel="noreferrer" style={{ color: "#fff", textDecoration: "underline", margin: "0 5px" }}>Terms & Conditions</a> |
                    <a href="https://latpay.com/wp-content/uploads/2023/11/Financial-Services-Guide-and-Product-Disclosure-Statement-final-V1.1-14.03.23.pdf" target="_blank" rel="noreferrer" style={{ color: "#fff", textDecoration: "underline", margin: "0 5px" }}>AU Financial Services Guide</a>
                </p>
                <p style={{ marginBottom: "0", maxWidth: "800px", margin: "auto" }}>
                    Lateral Payment Solutions Pty Ltd (Latpay) ABN 12 610 150 064 is the holder of an Australian Financial Services Licence (AFSL) No. 521901.
                </p>
            </div>

            {/* Footer logo */}
            <div style={{ backgroundColor: "#fff", padding: "10px", textAlign: "center" }}>
                <img
                    src="https://latpay.com/wp-content/uploads/2024/03/logos2.png"
                    alt="Supported Payments"
                    style={{ height: "45px", objectFit: "contain" }}
                />
            </div>
        </div>
    );
};

export default TokenGenerate;